<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="constnForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.constnCls }}</v-subheader>
              <div class="queryValue">{{ constnForm.constnCls }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.constnCls"
                v-model="constnForm.constnCls"
                :error-messages="errors.collect('constnForm.constnCls')"
                data-vv-name="constnForm.constnCls"
                :data-vv-as="labels.constnCls"
                append-icon="mdi-magnify"
                @click:append="getHelpList()"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.yrBlt }}</v-subheader>
              <div class="queryValue">{{ constnForm.yrBlt }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.yrBlt"
                v-model="constnForm.yrBlt"
                :error-messages="errors.collect('constnForm.yrBlt')"
                data-vv-name="constnForm.yrBlt"
                :data-vv-as="labels.yrBlt"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.preWar"
                v-model="constnForm.preWar"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.refurbish"
                v-model="constnForm.refurbish"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.wall }}</v-subheader>
              <div class="queryValue" v-for="item in filterWallList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="constnForm.wall"
                :label="labels.wall"
                item-text="label"
                item-value="value"
                data-vv-name="constnForm.wall"
                :data-vv-as="labels.wall"
                :error-messages="errors.collect('constnForm.wall')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.floor }}</v-subheader>
              <div class="queryValue" v-for="item in filterFloorList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="constnForm.floor"
                :label="labels.floor"
                item-text="label"
                item-value="value"
                data-vv-name="constnForm.floor"
                :data-vv-as="labels.floor"
                :error-messages="errors.collect('constnForm.floor')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.roof }}</v-subheader>
              <div class="queryValue" v-for="item in filterRoofList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="constnForm.roof"
                :label="labels.roof"
                item-text="label"
                item-value="value"
                data-vv-name="constnForm.roof"
                :data-vv-as="labels.roof"
                :error-messages="errors.collect('constnForm.roof')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.stairs }}</v-subheader>
              <div class="queryValue" v-for="item in filterStairsList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="constnForm.stairs"
                :label="labels.stairs"
                item-text="label"
                item-value="value"
                data-vv-name="constnForm.stairs"
                :data-vv-as="labels.stairs"
                :error-messages="errors.collect('constnForm.stairs')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noOpen }}</v-subheader>
              <div class="queryValue">{{ constnForm.noOpen }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noOpen"
                v-model="constnForm.noOpen"
                :error-messages="errors.collect('constnForm.noOpen')"
                data-vv-name="constnForm.noOpen"
                :data-vv-as="labels.noOpen"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noFireChkDoor }}</v-subheader>
              <div class="queryValue">{{ constnForm.noFireChkDoor }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noFireChkDoor"
                v-model="constnForm.noFireChkDoor"
                :error-messages="errors.collect('constnForm.noFireChkDoor')"
                data-vv-name="constnForm.noFireChkDoor"
                :data-vv-as="labels.noFireChkDoor"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.constnType }}</v-subheader>
              <div class="queryValue" v-for="item in filterConstnTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="constnTypeList"
                v-model="constnForm.constnType"
                :label="labels.constnType"
                item-text="label"
                item-value="value"
                data-vv-name="constnForm.constnType"
                :data-vv-as="labels.constnType"
                :error-messages="errors.collect('constnForm.constnType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3></v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">DETACHED/SEMI-DETACHED</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-checkbox
                color="primary"
                :label="labels.extn"
                v-model="constnForm.extn"
                :disabled="riskSurveyMode === 'Query' ? true : false"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.extnConstn }}</v-subheader>
              <div class="queryValue">{{ constnForm.extnConstn }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.extnConstn"
                v-model="constnForm.extnConstn"
                :error-messages="errors.collect('constnForm.extnConstn')"
                data-vv-name="constnForm.extnConstn"
                :data-vv-as="labels.extnConstn"
                v-validate="'entry|max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">TERRACE</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noUnitTerr }}</v-subheader>
              <div class="queryValue">{{ constnForm.noUnitTerr }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noUnitTerr"
                v-model="constnForm.noUnitTerr"
                :error-messages="errors.collect('constnForm.noUnitTerr')"
                data-vv-name="constnForm.noUnitTerr"
                :data-vv-as="labels.noUnitTerr"
                v-validate="'numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.occpnTerr }}</v-subheader>
              <div class="queryValue">{{ constnForm.occpnTerr }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.occpnTerr"
                v-model="constnForm.occpnTerr"
                :error-messages="errors.collect('constnForm.occpnTerr')"
                data-vv-name="constnForm.occpnTerr"
                :data-vv-as="labels.occpnTerr"
                v-validate="'entry|max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">HIGH-RISE</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noUnitHr }}</v-subheader>
              <div class="queryValue">{{ constnForm.noUnitHr }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.noUnitHr"
                v-model="constnForm.noUnitHr"
                :error-messages="errors.collect('constnForm.noUnitHr')"
                data-vv-name="constnForm.noUnitHr"
                :data-vv-as="labels.noUnitHr"
                v-validate="'numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.occpnHr }}</v-subheader>
              <div class="queryValue">{{ constnForm.occpnHr }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.occpnHr"
                v-model="constnForm.occpnHr"
                :error-messages="errors.collect('constnForm.occpnHr')"
                data-vv-name="constnForm.occpnHr"
                :data-vv-as="labels.occpnHr"
                v-validate="'entry|max:50'"
              ></v-text-field>
            </v-flex>
            <v-flex md3 lg3></v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.strataTitle }}</v-subheader>
              <div class="queryValue">{{ constnForm.strataTitle }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.strataTitle"
                v-model="constnForm.strataTitle"
                :error-messages="errors.collect('constnForm.strataTitle')"
                data-vv-name="constnForm.strataTitle"
                :data-vv-as="labels.strataTitle"
                v-validate="'entry|max:15'"
              ></v-text-field>
            </v-flex>
            <v-flex md6 lg6></v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">ADJOINING RISK</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.nearBldg }}</v-subheader>
              <div class="queryValue">{{ constnForm.nearBldg }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-text-field
                :label="labels.nearBldg"
                v-model="constnForm.nearBldg"
                :error-messages="errors.collect('constnForm.nearBldg')"
                data-vv-name="constnForm.nearBldg"
                :data-vv-as="labels.nearBldg"
                v-validate="'numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.adjUnitOccpn }}</v-subheader>
              <div class="queryValue">{{ constnForm.adjUnitOccpn }}</div>
            </v-flex>
            <v-flex xs12 md6 lg6 v-else>
              <v-text-field
                :label="labels.adjUnitOccpn"
                v-model="constnForm.adjUnitOccpn"
                :error-messages="errors.collect('constnForm.adjUnitOccpn')"
                data-vv-name="constnForm.adjUnitOccpn"
                :data-vv-as="labels.adjUnitOccpn"
                v-validate="'entry|max:20'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.constnRemarks }}</v-subheader>
              <div class="queryValue">{{ constnForm.constnRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="constnForm.constnRemarks"
                :label="labels.constnRemarks"
                :error-messages="errors.collect('constnForm.constnRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="constnForm.constnRemarks"
                :data-vv-as="constnForm.constnRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>

    <v-dialog v-model="showFireConstrnClsHelpList" width="1080px">
      <fire-constrn-cls-help-list @close="showFireConstrnClsHelpList = false" @assign-fireConstrnCls="doAssign($event)"></fire-constrn-cls-help-list>
    </v-dialog>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { materialList, constnTypeList } from './index'
import FireConstrnClsHelpList from '@/components/core/common/dialog/FireConstrnClsHelpList'

export default {
  data() {
    return {
      labels: {
        constnCls: 'Construction Class',
        yrBlt: 'Year Built',
        preWar: 'Pre-War',
        refurbish: 'Refurbished',
        wall: 'Wall',
        floor: 'Floor',
        roof: 'Roof',
        stairs: 'Stairs',
        noOpen: 'Total No. Openings',
        noFireChkDoor: 'Total No. Protected by Fire-Check Door',
        constnType: 'Construction Type',
        extn: 'Extension',
        extnConstn: 'Construction',
        noUnitTerr: 'No. of Units',
        occpnTerr: 'Mostly Occupied As',
        noUnitHr: 'No. of Units',
        occpnHr: 'Mostly occupied As',
        strataTitle: 'MC Strata Title',
        nearBldg: 'Nearest Building',
        adjUnitOccpn: 'Building Occupied As',
        constnRemarks: 'Construction Details Comments'
      },
      constnForm: {
        survNo: undefined,
        verCnt: undefined,
        constnCls: undefined,
        yrBlt: undefined,
        preWar: false,
        refurbish: false,
        wall: undefined,
        floor: undefined,
        roof: undefined,
        stairs: undefined,
        noOpen: undefined,
        noFireChkDoor: undefined,
        constnType: undefined,
        extn: false,
        extnConstn: undefined,
        noUnitTerr: undefined,
        occpnTerr: undefined,
        noUnitHr: undefined,
        occpnHr: undefined,
        strataTitle: undefined,
        nearBldg: undefined,
        adjUnitOccpn: undefined,
        constnRemarks: undefined,
        survDetType: 'construction'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      materialList: [],
      constnTypeList: [],
      showFireConstrnClsHelpList: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    filterWallList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.constnForm.wall)
      })
    },
    filterFloorList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.constnForm.floor)
      })
    },
    filterRoofList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.constnForm.roof)
      })
    },
    filterStairsList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.constnForm.stairs)
      })
    },
    filterConstnTypeList() {
      return this.constnTypeList.filter((list) => {
        return list.value === parseInt(this.constnForm.constnType)
      })
    }
  },
  methods: {
    async doInit() {
      // if (this.riskSurveyMode === 'New') {
      //   this.$store.commit(RISK_SURVEY_DETAILS, this.constnForm)
      // } else {
      this.constnForm.survNo = this.riskSurveyMaster.survNo
      this.constnForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
      // }
    },
    async loadInit() {
      this.constnForm.constnCls = this.riskSurveyDetails.constnCls
      this.constnForm.yrBlt = this.riskSurveyDetails.yrBlt
      this.constnForm.preWar = this.riskSurveyDetails.preWar
      this.constnForm.refurbish = this.riskSurveyDetails.refurbish
      this.constnForm.wall = parseInt(this.riskSurveyDetails.wall)
      this.constnForm.floor = parseInt(this.riskSurveyDetails.floor)
      this.constnForm.roof = parseInt(this.riskSurveyDetails.roof)
      this.constnForm.stairs = parseInt(this.riskSurveyDetails.stairs)
      this.constnForm.noOpen = this.riskSurveyDetails.noOpen
      this.constnForm.noFireChkDoor = this.riskSurveyDetails.noFireChkDoor
      this.constnForm.constnType = parseInt(this.riskSurveyDetails.constnType)
      this.constnForm.extn = this.riskSurveyDetails.extn
      this.constnForm.extnConstn = this.riskSurveyDetails.extnConstn
      this.constnForm.noUnitTerr = this.riskSurveyDetails.noUnitTerr
      this.constnForm.occpnTerr = this.riskSurveyDetails.occpnTerr
      this.constnForm.noUnitHr = this.riskSurveyDetails.noUnitHr
      this.constnForm.occpnHr = this.riskSurveyDetails.occpnHr
      this.constnForm.strataTitle = this.riskSurveyDetails.strataTitle
      this.constnForm.nearBldg = this.riskSurveyDetails.nearBldg
      this.constnForm.adjUnitOccpn = this.riskSurveyDetails.adjUnitOccpn
      this.constnForm.constnRemarks = this.riskSurveyDetails.constnRemarks
    },
    getHelpList() {
      this.showFireConstrnClsHelpList = true
    },
    doAssign(data) {
      this.constnForm.constnCls = data
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.constnForm.constnCls = undefined
      this.constnForm.yrBlt = undefined
      this.constnForm.preWar = false
      this.constnForm.refurbish = false
      this.constnForm.wall = undefined
      this.constnForm.floor = undefined
      this.constnForm.roof = undefined
      this.constnForm.stairs = undefined
      this.constnForm.noOpen = undefined
      this.constnForm.noFireChkDoor = undefined
      this.constnForm.constnType = undefined
      this.constnForm.extn = false
      this.constnForm.extnConstn = undefined
      this.constnForm.noUnitTerr = undefined
      this.constnForm.occpnTerr = undefined
      this.constnForm.noUnitHr = undefined
      this.constnForm.occpnHr = undefined
      this.constnForm.strataTitle = undefined
      this.constnForm.nearBldg = undefined
      this.constnForm.adjUnitOccpn = undefined
      this.constnForm.constnRemarks = undefined
    }
  },
  created() {
    this.materialList = materialList
    this.constnTypeList = constnTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {
    FireConstrnClsHelpList
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
